import { render, staticRenderFns } from "./SelectGoods.vue?vue&type=template&id=3617cfde&scoped=true&"
import script from "./SelectGoods.vue?vue&type=script&lang=js&"
export * from "./SelectGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3617cfde",
  null
  
)

export default component.exports